module.exports = __webpack_public_path__ + "img/hotelFamily-3.b1196c53.jpg";